import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-components-translations-CanvasView', [
  'languageBar',
  'languageBarDrag',
  'languageBarSwitch',
  'languageBarReadOnly',
  'languageBarEdit',
  'languageBarClose',
  'translatedNode',
  'nodeEdit',
]);
